/**
 * Detects if a URL is a Figma URL
 */
export function isFigmaUrl(url: string): boolean {
  if (!url) return false;
  const normalized = url.toLowerCase().trim();
  return normalized.includes('figma.com') || normalized.includes('figma.design');
}

export const FIGMA_BLOCK_MESSAGE = {
  el: 'Τα Figma URLs υποστηρίζονται μόνο μέσω της Figma Analysis. Χρησιμοποιήστε τη Figma Analysis για ανάλυση mockups.',
  en: 'Figma URLs are only supported through Figma Audit. Use Figma Audit for mockup audits.',
};
